export interface ITitle {
    title_id: string,
    tags: string[],
    title: string,
}

export class Titles {
    constructor(public readonly data: { [key: string]: ITitle }) {
        //
    }

    filter(tags: string[]): string[] {
        return Object.values(this.data).filter(it => tags.slice(1).every(t => it.tags.includes(t))).map(it => it.title);
    }
}
